import { HttpService } from './../http.service';
import { Component, OnInit } from '@angular/core';
import { ThemePalette, ProgressSpinnerMode} from '@angular/material';
import { GlobalService } from '../global.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

@Component({
  selector: 'app-bank-transaction-excel-file-upload',
  templateUrl: './bank-transaction-excel-file-upload.component.html',
  styleUrls: ['./bank-transaction-excel-file-upload.component.scss']
})
export class BankTransactionExcelFileUploadComponent implements OnInit {
  title: any;
  file: any;
  excel_base_64: any;
  excel_upload_button: boolean = false;
  uploaded_excel_details: any;
  spinner: boolean = false;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';

  constructor(private http: HttpService, public global: GlobalService) {

    this.bankTransactionUploadDetails();
    // console.info('User Type:', this.global.user_type);

  }

  bankTransactionUploadDetails() {
    this.http.bankTransactionUploadDetails().subscribe((data) => {
      this.title = this.global._active_display_name;
      this.uploaded_excel_details = data;
    }, (error) => {
      this.spinner = false;
      console.log(error);
      alert("Process Not Completed Error Occured !!!")
    })
  }

  uploadClicked() {
    this.spinner = true;
    let data_dict = {
      'file_name': this.file,
      'base_64_excel': this.excel_base_64
    }
    this.http.bankTransactionExcelUpload(data_dict).subscribe((data) => {
      console.log('is data is uploaded' ,data['uploaded'])
      if(data['uploaded'] == true){
        alert("Data Upload Completed !!!")
        this.spinner = false;
        this.file = null;
        this.bankTransactionUploadDetails();
        this.excel_upload_button = false;
      }else{
        this.spinner = false;
        this.file = null;
        this.bankTransactionUploadDetails();
        this.excel_upload_button = false;
        alert("Error While Uploading !!!")
      }

    }, (error) => {
      this.spinner = false;
      console.error(error);
    });

  }

  excelUploadClicked() {
    this.excel_upload_button = true;
  }


  handleUpload(event) {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
        console.log(reader.result);
        this.excel_base_64 = reader.result;
    };
  }


  ngOnInit() {
  }


  deleteFile(excel: any) {
    if (confirm('Are you sure you want to delete this file?')) {
        console.log('Deleted file at excel:', excel);
        
        this.http.deletebankTransactionExcelUpload(excel.id).subscribe(
            (data) => {
                console.log('File deleted successfully', data);
            }, 
            (error) => {
                this.spinner = false;
                console.error('Error deleting file:', error);
            }
        );
        this.bankTransactionUploadDetails()
    }
}
  
}
